// File: packages/ui/src/LoadingSpinner.tsx
// Version: 2026.4.1 | ForgeTrack loading spinner

import { ENGINE_COLORS as C } from '@forgetrack/theme';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  label?: string;
}

export function LoadingSpinner({ size = 32, color = C.neon, label }: LoadingSpinnerProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
      <svg width={size} height={size} viewBox="0 0 24 24" style={{ animation: 'engine-icon-spin 1s linear infinite' }}>
        <circle cx="12" cy="12" r="10" fill="none" stroke={`${color}30`} strokeWidth="2.5" />
        <path d="M12 2a10 10 0 0 1 10 10" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      {label && (
        <span style={{ fontSize: 12, color: C.muted, fontFamily: "'Outfit', sans-serif" }}>
          {label}
        </span>
      )}
    </div>
  );
}
